import { statusType } from './statusType';

export const seCeStatus = {
  LOADING: {
    type: statusType.INITIAL,
    text: "We're setting up your account. This may take a few minutes.",
  },
  REGISTERING: {
    type: statusType.PENDING,
    text: 'Registering your account with Veeqo',
  },
  CHANNELS: {
    type: statusType.PENDING,
    text: 'Connecting your amazon channels',
  },
  BOXES: {
    type: statusType.PENDING,
    text: 'Making sure all your boxes are facing the same way',
  },
  READY: {
    type: statusType.READY,
    text: 'Everything is ready. Time to get started!',
  },
  ERROR: {
    type: statusType.ERROR,
    text: 'Something went wrong. Please try again later.',
  },
};

export const seCeContent = {
  title: 'Please wait',
  status: seCeStatus,
};
